import { createReducer } from 'redux-act';
import isEmpty from 'lodash/isEmpty';
import identity from 'lodash/identity';
import { setupModal, teardownModal, displayModal } from './actions';

const createInitialState = () => ({
  isOpen: false,
  variant: 'info',
  header: '',
  body: '',
  button: 'Close',
  onClose: identity,
  onButtonClick: identity,
});

const modalReducer = createReducer(
  {
    [setupModal]: (state, modalProps) => ({
      ...createInitialState(),
      ...modalProps,
    }),
    [teardownModal]: () => createInitialState(),
    [displayModal]: (state) => ({
      ...state,
      isOpen: !isEmpty(state.header) && !isEmpty(state.body),
    }),
  },
  createInitialState(),
);

export default modalReducer;
